export { CollapseMenuComponent } from './collapse-menu.component';



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/shared/layout/header/collapse-menu/index.ts